module.exports = __webpack_public_path__ + "img/FINTI-logo.22f98743.svg";